import { render, staticRenderFns } from "./manageIndustryModal.vue?vue&type=template&id=2a122849&scoped=true&"
import script from "./manageIndustryModal.vue?vue&type=script&lang=js&"
export * from "./manageIndustryModal.vue?vue&type=script&lang=js&"
import style0 from "./manageIndustryModal.vue?vue&type=style&index=0&id=2a122849&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a122849",
  null
  
)

export default component.exports